<template>
  <section :class="$style.container">
    <header :class="$style.header">
      <p :class="$style.title">
        <slot name="title"></slot>
      </p>
      <slot name="right"></slot>
    </header>
    <div v-if="showSubtitle" :class="$style.subtitleWrapper">
      <slot name="subtitle"></slot>
      <div>
        <slot name="subtitleButton"></slot>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    showSubtitle?: boolean
  }>(),
  {
    showSubtitle: false,
  }
)
</script>

<style lang="scss" module>
.container {
  border-bottom: 1px solid $color-border-low-emphasis;
  padding-bottom: 26px;
  margin-bottom: 16px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-size: 24px;
  font-weight: 700;
}

.subtitleWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}
</style>
